import { useSelector } from 'react-redux';
import {
  getSupplierMatchComponent,
  SUBCATEGORY_MAX_MATCHES_DEFAULT,
} from '../../Helpers/supplierMatches';

const customerMatchToOption = (match) => ({
  id: match.brandId,
  value: match.brandLabel,
  icon_url: match.brandLogoUrl,
});

/**
 * Note: This is the order of precedence for options:
 * 1. Supplier match component (excluding what has been deselected)
 * 2. Customer matches
 * 3. Subcategory matches
 *
 * The customer is being matched to a "brand", but as a company we refer to brands
 * as suppliers. There may be one or many suppliers under one brand.
 */
const useSupplierMatch = () => {
  const components = useSelector((store) => store?.components || {});
  const { customerMatches, subcategoryMatches, subcategoryMaxMatches } =
    useSelector((store) => store?.supplierMatches || {});
  const supplierMatchComponent = getSupplierMatchComponent({ components });
  const customerMatchOptions = customerMatches?.map(customerMatchToOption);

  const subcategoryMatchOptions = subcategoryMatches?.map(
    customerMatchToOption
  );

  const input = supplierMatchComponent?.input || {};
  let options = [];

  if (input?.options && input.options.length > 0) {
    options = input.options;
  } else if (customerMatchOptions && customerMatchOptions.length > 0) {
    options = customerMatchOptions;
  } else if (subcategoryMatchOptions && subcategoryMatchOptions.length > 0) {
    options = subcategoryMatchOptions;
  }

  let selectedOptions = input?.selectedOptions || [];

  if (!supplierMatchComponent) {
    if (customerMatchOptions?.length > 0) {
      selectedOptions = customerMatchOptions;
    }

    if (
      !customerMatchOptions?.length > 0 &&
      subcategoryMatchOptions?.length > 0
    ) {
      selectedOptions = subcategoryMatchOptions;
    }
  }

  let filteredOptions = selectedOptions;

  if (supplierMatchComponent && options?.length > 0) {
    filteredOptions = options.filter((option) =>
      selectedOptions.includes(String(option?.id))
    );
  }

  const maxMatchesToDisplay =
    subcategoryMaxMatches || SUBCATEGORY_MAX_MATCHES_DEFAULT;

  /**
   * We would have already filtered to the options displayed in the supplier match
   * component if it exists, so we only need to filter the options by subcategory
   * max matches now. This is only used when there is no supplier match component
   * on the page.
   */
  if (filteredOptions.length > maxMatchesToDisplay) {
    filteredOptions = filteredOptions.slice(0, maxMatchesToDisplay);
  }

  return { matchedAndFilteredBrands: filteredOptions };
};

export default useSupplierMatch;
